import { APP_NAME } from '@clanfire/shared';
import { BadgeCheck, Crown, Gavel, ShieldCheck, type AppIcon } from '@/components/ui/icons';
import type { StaffRole } from '@clanfire/shared';
import { Tooltip } from '@/components/ui/Popover';
import { cn } from '@/lib/utils';

const BADGES: Record<StaffRole, { label: string; title: string; icon: AppIcon; className: string }> = {
  CEO: {
    label: 'CEO',
    title: `${APP_NAME} CEO`,
    icon: Crown,
    className: 'bg-gradient-to-r from-[#f59e0b] via-[#fcd34d] to-[#f59e0b] text-[#3b2503] shadow-[0_0_10px_rgba(251,191,36,0.45)]',
  },
  ADMIN: { label: 'STAFF', title: `${APP_NAME} Admin`, icon: ShieldCheck, className: 'bg-accent text-accent-fg' },
  MODERATOR: { label: 'MOD', title: `${APP_NAME} Moderator`, icon: Gavel, className: 'bg-[#56633f] text-[#f5ead8]' },
  SYSTEM: { label: 'OFFICIAL', title: `Official ${APP_NAME} account`, icon: BadgeCheck, className: 'bg-[#3d472b] text-[#f5ead8]' },
};

/**
 * ClanFire staff tag shown next to names (chat, member list, profiles). The CEO's
 * shows as a profile badge instead, so it only appears here with `always` (the staff panel).
 */
export function StaffBadge({ role, size = 'sm', always = false, className }: { role: StaffRole | null | undefined; size?: 'sm' | 'md'; always?: boolean; className?: string }) {
  if (!role || (role === 'CEO' && !always)) return null;
  const badge = BADGES[role];
  const Icon = badge.icon;
  return (
    <Tooltip label={badge.title}>
      <span
        aria-label={badge.title}
        className={cn(
          'inline-flex shrink-0 items-center gap-0.5 rounded-full font-extrabold tracking-wide select-none',
          size === 'sm' ? 'h-4 px-1.5 text-[9.5px] leading-none' : 'h-5 px-2 text-[11px]',
          badge.className,
          className,
        )}
      >
        <Icon size={size === 'sm' ? 10 : 12} strokeWidth={2.6} aria-hidden />
        {badge.label}
      </span>
    </Tooltip>
  );
}
